import { getFileSpriteIconClass } from 'owa-file-icon';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import * as React from 'react';

const classNames = require('classnames/bind');
const styles = require('./fileProvidersIcon.scss');

export default function getIconForFileProvider(icon: string, className: string): JSX.Element {
    return <Icon iconName={icon} className={className} />;
}

export function getIconForGDrive(): JSX.Element {
    return (
        <Icon
            className={classNames([styles.pngGoogleIcon, getFileSpriteIconClass('gdrive_24x24')])}
            tabIndex={-1}
            data-is-focusable={false}
        />
    );
}
